import api from '@/api';
import precision from '@/utils/precision';

const state = {
  loading: false,
  recId: '',

  billAlertInfo: '', // 提单页动态信息

  billInfo: {}, // 提单页信息
  compList: [], // 组件列表
  compMap: {
    // 1: [], 组件类型映射表（根据type类型）
  },
  remark: null,
  cateInfo: null
};

const mutations = {
  setBillInfo(state, data) {
    const { recId = '', sections = [] } = data;
    const compList = [];
    const compMap = {};

    sections.forEach(sectionItem => {
      if (sectionItem.components) {
        sectionItem.components.forEach(compItem => {
          compList.push(compItem);
        });
      }
    });
    if (compList.length > 0) {
      compList.forEach(item => {
        if (compMap[item.type]) {
          compMap[item.type].push(item);
        } else {
          compMap[item.type] = [];
          compMap[item.type].push(item);
        }
      });
    }
    state.recId = recId;
    state.billInfo = data;
    state.compList = compList;
    state.compMap = compMap;
    state.remark = compMap[8] ? compMap[8][0] : null;
    state.cateInfo = compMap[5] ? compMap[5][0] : null;
  },
  setBillAlertInfo(state, data) {
    const { alertInfo = {} } = data;
    const { content = '' } = alertInfo;
    state.billAlertInfo = content;
  },
};

const actions = {
  /** EFO等活动专区 获取提单页信息 */
  async getBillInfoFastBuy({ state }, param) {
    try {
      let res = await api.apiFastBuy(param);
      if (res) {
        res = precision.transBillInfo(res);
      }
      return res
    } catch {
    }
    return false
  },
  /** @desc 获取提单页信息 */
  async getBillInfo({ commit, state }, param) {
    state.loading = true;
    try {
      let res = await api.apiBillInfo(param);
      if (res) {
        res = precision.transBillInfo(res);
      }
      commit('setBillInfo', res);
    } catch {
    }

    state.loading = false;
  },
  /** @desc 更新提单页信息 */
  async updateBillInfo({ commit, state }, param) {
    state.loading = true;
    try {
      let res = await api.apiBillUpdate(param);
      if (res) {
        res = precision.transBillInfo(res);
      }
      res = precision.transBillInfo(res);
      commit('setBillInfo', res);
    } catch {
    }
    state.loading = false;
  },
  /** @desc 获取提单页动态信息 */
  async getBillAlert({ commit, state }, param) {
    state.loading = true;
    try {
      const res = await api.apiBillAlert(param);
      commit('setBillAlertInfo', res);
    } catch {
    }
    state.loading = false;
  },
  async recoveryBill(
    { commit, state }, { orderId, paymentError, shouldCancelOrder = true }) {
    // 先取消订单，再恢复购物车
    // 以恢复购物车的结果，为整个recovery的结果（取消订单）
    try {
      // 取消订单失败，不影响恢复购物车
      shouldCancelOrder && await api.cancelOrder({ orderId, paymentError });
    } catch (e) {
    }

    let res = await api.recoveryCart({ orderId });
    res = precision.transBillInfo(res);
    return res;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
